<span class="minfy-ui-change-request-status"
  [ngClass]="{success: status == 'Approved' || status == 'Succeeded', light: status == 'Pending Approval', danger: status == 'Rejected' || status == 'Failed', not_executed: !status}">
  {{status || "Didn't Run"}}
</span>